"use client";

import { Footer } from "@/components/footer";
import { Kwan } from "@/components/page/kwan/kwan";
import { Introduction } from "@/components/page/kwan/introduction";
import { Problem } from "@/components/page/kwan/problem";
import { GlobalNetwork } from "@/components/page/kwan/globalNetwork";
import { Principle } from "@/components/page/kwan/principle";
import { AutofitPageWrapper } from "@/components/AutofitPageWrapper";
import { Advantages } from "@/components/page/kwan/advantages";
import { Fuwu } from "@/components/page/kwan/fuwu";
import { useIsMobile } from "@/app/hooks/useIsMobile";
import { MobileFooter } from "@/components/mobile-footer";
import { HeaderMobile } from "@/components/header-mobile";
import { KwanMobileFirst } from "@/components/page/kwan-mobile/first";
import { KwanMobileSecond } from "@/components/page/kwan-mobile/second";
import { KwanMobileThree } from "@/components/page/kwan-mobile/three";
import { KwanMobileFourth } from "@/components/page/kwan-mobile/fourth";
import { KwanMobileFive } from "@/components/page/kwan-mobile/five";

export default function KwanPageClient() {
  const isMobile = useIsMobile();

  if (isMobile === null)
    return (
      <div
        className="w-screen h-screen"
        style={{ background: "linear-gradient(135deg, rgba(250,231,237,1) 2.885%, rgba(82,160,252,1) 56.731%, rgba(59,225,254,1) 97.596%)" }}
      />
    );

  if (isMobile) {
    return (
      <div className="flex flex-col w-full h-screen overflow-y-auto">
        <HeaderMobile />
        <KwanMobileFirst />
        <KwanMobileSecond />
        <KwanMobileThree />
        <KwanMobileFourth />
        <KwanMobileFive />
        <MobileFooter />
        <div className="h-[20px] min-h-[20px]" />
      </div>
    );
  }

  return (
    <AutofitPageWrapper>
      <Kwan />
      <Problem />
      <Introduction />
      <GlobalNetwork />
      <Principle />
      <Advantages />
      <Fuwu />
      <Footer />
    </AutofitPageWrapper>
  );
}

